import axios from "axios";
import { environment } from "../../../environments/environment";


export function  getStoresInfo(partId){
    return axios.get(`${environment.getStoresInfo}?partId=${partId}`)
}

export function createStoresInfo(info, partId){
    return axios.post(`${environment.saveStoreInfo}?partId=${partId}`, info);
}
export function updateStoresInfo(info, partId){
    return axios.put(`${environment.saveStoreInfo}?partId=${partId}`, info);
}